<template>
  <div class="breadcrumbs">
    <span v-for="(crumb, index) in crumbs" :key="index" @click="crumbClicked(crumb)">
      <span class="pointer underlined">{{ crumb.title }}</span>
      <span> / </span>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['crumbs'])
  },

  methods: {
    crumbClicked(crumb) {
      this.$router.push(crumb.to)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/General/Breadcrumbs.vue